import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Form, Radio } from 'semantic-ui-react';
import { last, first } from 'lodash';
import {
    subMilliseconds,
    subSeconds,
    subMinutes,
    subHours,
    subDays,
    subWeeks,
    subMonths,
    subQuarters,
    subYears
} from 'date-fns';

export default class TimeSpanFilter extends Component {
    constructor(props) {
        super(props);

        this.state = { value: null };
    }
    handleChange = (e, { value }) => {
        this.setState({ value }, () => this.props.filterChangedCallback());
    };

    isFilterActive() {
        return (
            this.state.value !== null && this.state.value !== undefined && this.state.value !== ''
        );
    }
    onFloatingFilterChanged(changed) {
        this.setState({ value: null }, () => this.props.filterChangedCallback());
    }
    doesFilterPass({ node }) {
        const dateValue = new Date(this.props.valueGetter(node));
        const timespan = this.state.value.replace(/last /g, '').split(' ');
        const unit = last(timespan).toLowerCase();
        let amount = 1;
        if (timespan.length > 1) {
            amount = Number(first(timespan));
            if (isNaN(amount)) {
                if (first(timespan).toLowerCase() === 'half') {
                    amount = 0.5;
                } else {
                    amount = 1;
                }
            }
        }

        let cutoffDate = new Date(-8640000000000000);
        switch (unit) {
            case 'milliseconds':
            case 'millisecond':
            case 'ms':
                cutoffDate = subMilliseconds(new Date(), amount);
                break;
            case 'seconds':
            case 'second':
            case 'secs':
            case 'sec':
            case 's':
                cutoffDate = subSeconds(new Date(), amount);
                break;
            case 'minutes':
            case 'minute':
            case 'mins':
            case 'min':
            case 'm':
                cutoffDate = subMinutes(new Date(), amount);
                break;
            case 'hours':
            case 'hour':
            case 'h':
                cutoffDate = subHours(new Date(), amount);
                break;
            case 'days':
            case 'day':
            case 'd':
                cutoffDate = subDays(new Date(), amount);
                break;
            case 'weeks':
            case 'week':
            case 'w':
                cutoffDate = subWeeks(new Date(), amount);
                break;
            case 'months':
            case 'month':
                cutoffDate = subMonths(new Date(), amount);
                break;
            case 'quarters':
            case 'quarter':
            case 'qtr':
                cutoffDate = subQuarters(new Date(), amount);
                break;
            case 'years':
            case 'year':
            case 'y':
                cutoffDate = subYears(new Date(), amount);
                break;
        }
        return dateValue >= cutoffDate;
    }

    getModel() {
        return this.state.value ? [this.state.value] : null;
    }

    setModel(model) {
        this.state.value = model ? first(model) : '';
    }

    afterGuiAttached(params) {
        this.focus();
    }

    focus() {
        setTimeout(() => {
            let container = ReactDOM.findDOMNode(this.refs.input);
            if (container) {
                container.focus();
            }
        });
    }

    componentMethod(message) {
        alert(`Alert from PartialMatchFilterComponent ${message}`);
    }

    render() {
        return (
            <Form style={{ padding: '.5rem' }}>
                {this.props.values.map(value => (
                    <Form.Field>
                        <Radio
                            label={value}
                            name="options"
                            value={value}
                            checked={this.state.value === value}
                            onChange={this.handleChange}
                        />
                    </Form.Field>
                ))}
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./components/atoms/TimeSpanFilter.jsx